export function calculateHoverColor(themeColor, luminanceAdjustment) {
  if (!themeColor) {
    return;
  }
  // Parse the hexadecimal color string to RGB components
  var r = parseInt(themeColor.substring(1, 3), 16);
  var g = parseInt(themeColor.substring(3, 5), 16);
  var b = parseInt(themeColor.substring(5, 7), 16);

  // Calculate the luminance (brightness) of the theme color
  var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Define the amount by which to adjust the color for hover
  var adjustment = luminance > 0.5 ? -luminanceAdjustment : luminanceAdjustment; // Darken for light themes, lighten for dark themes

  // Calculate the hover color components
  var hoverR = Math.round(Math.min(Math.max(r + adjustment * 255, 0), 255));
  var hoverG = Math.round(Math.min(Math.max(g + adjustment * 255, 0), 255));
  var hoverB = Math.round(Math.min(Math.max(b + adjustment * 255, 0), 255));

  // Convert the hover color components back to hexadecimal
  var hoverColor = "#" + ((1 << 24) + (hoverR << 16) + (hoverG << 8) + hoverB).toString(16).slice(1);

  return hoverColor;
}

export const getThemeColors = (config) => {
  let { theme, font_color, background_color } = config || {};

  if (theme === "dark") {
    background_color = "#242424"
    font_color = "#FFFFFF"
  } else if (theme === "light") {
    background_color = "#FFFFFF";
    font_color = "#242424"
  }

  return JSON.parse(JSON.stringify({
    hoverColorSecondary: calculateHoverColor(font_color, 0.8),
    hoverColor: calculateHoverColor(font_color, 0.7),
    colorBgLayout: `radial-gradient(circle,${background_color}, ${calculateHoverColor(background_color, 0.3)})`,
    fontFamily: "Roboto",
    colorLink: font_color,
    colorLinkHover: calculateHoverColor(background_color, 0.5),
    backgroundColor: background_color,
    colorText: font_color
  }));
}

export const buildHeaderImgObj = (headers) => {
  let newHeaderObj = [];
  if (Array.isArray(headers)) {
    newHeaderObj = headers.map((header) => {
      if (typeof header === "object" && "url" in header) {
        return header;
      } else {
        return ({
          url: header
        });
      }
    });
  } else {
    if (!!headers) {
      newHeaderObj = [{
        url: headers
      }];
    }
  }

  return newHeaderObj;
}
